import { PreviewItemFilters } from "./preview-item-filters";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { FilteredPreviewItem } from "./filtered-preview-item";
import { PreviewItemFilterOption } from "./preview-item-filter-option";

/**
 * Default implementation of a {@link PreviewItemFilters} that returns all as visible.
 */
export class DefaultItemFilter extends PreviewItemFilters {
    public constructor(events: EventBroker) {
        super(events);
    }

    public override getFilterOptions(): PreviewItemFilterOption[] {
        return [];
    }

    public prepare(previewItems: FilteredPreviewItem[]): void {
        
    }

    public override postVisibleCheck(): void {
        // ... nothing ...
    }
    
    public isVisible(item: FilteredPreviewItem): boolean {
        return true;
    }

    public override sort(previewItems: FilteredPreviewItem[]): void {
        // ... nothing ...
    }

    public override setUserInfo(isCollection: boolean, isAuthed: boolean): void {
        // ... nothing ...
    }
}